export default function SiteBackdrop() {
  return (
    <iframe
      aria-hidden="true"
      className="site-freeway-backdrop"
      src="/preserved/Bridge%20Deck%20Night.dc.html?v=light-responsive-v4"
      tabIndex={-1}
      title="Animated freeway background"
    />
  )
}
